import {baseAPIGenerationUrl, baseAPIUrl, baseUrl} from "../constants";



export async function fetchDashboardData(login, password, ref = null) {
    const response = await fetch(`${baseAPIUrl}/dashboard_data`, {
        method: "POST",
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ login, password, ref: ref || undefined }),
    });

    if (response.status !== 200) {
        const error = await response.json();
        throw new Error(error.detail || 'Failed to fetch dashboard data');
    }

    return await response.json();
}


export async function fetchDashboardDataV1(token, ref = null) {
    if (!token) {
        return null;
    }

    const refParam = ref ? `?ref=${ref}` : "";

    const response = await fetch(`${baseAPIUrl}/get_ref_data${refParam}`, {
        method: "GET",
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
    });

    if (response.status !== 200) {
        const error = await response.json();
        throw new Error(error.detail || 'Failed to fetch dashboard data');
    }

    return await response.json();
}


async function getRevData(token, path) {
    if (!token) {
        return null;
    }
    const response = await fetch(`${baseAPIUrl}/revdata${path}`, {
        method: "GET",
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
    });
    if (response.status !== 200) {
        const error = await response.json().catch(() => ({}));
        throw new Error(error.detail || `Failed to fetch ${path}`);
    }
    return await response.json();
}


export async function fetchRevDataSources(token) {
    return getRevData(token, "/sources");
}


export async function fetchRevDataToday(token) {
    return getRevData(token, "/today");
}


export async function fetchRevDataDaily(token, {days = 90, refs = [], ext = []} = {}) {
    const params = new URLSearchParams();
    if (days && days !== 90) {
        params.set("days", String(days));
    }
    if (refs && refs.length > 0) {
        params.set("refs", refs.join(","));
    }
    if (ext && ext.length > 0) {
        params.set("ext", ext.join(","));
    }
    const qs = params.toString();
    return getRevData(token, qs ? `/daily?${qs}` : "/daily");
}


// no ext here: external sources are not in the subscriptions table this reads
export async function fetchRevDataSubsDaily(token, {days = 90, refs = []} = {}) {
    const params = new URLSearchParams();
    if (days && days !== 90) {
        params.set("days", String(days));
    }
    if (refs && refs.length > 0) {
        params.set("refs", refs.join(","));
    }
    const qs = params.toString();
    return getRevData(token, qs ? `/subs_daily?${qs}` : "/subs_daily");
}


export async function fetchRevDataRebills(token, {days = 90} = {}) {
    const params = new URLSearchParams();
    if (days && days !== 90) {
        params.set("days", String(days));
    }
    const qs = params.toString();
    return getRevData(token, qs ? `/rebills?${qs}` : "/rebills");
}


export async function fetchRevDataChurn(token, {days = 182} = {}) {
    const params = new URLSearchParams();
    if (days && days !== 182) {
        params.set("days", String(days));
    }
    const qs = params.toString();
    return getRevData(token, qs ? `/churn?${qs}` : "/churn");
}


export async function fetchRevDataChurnExternal(token, {days = 182} = {}) {
    const params = new URLSearchParams();
    if (days && days !== 182) {
        params.set("days", String(days));
    }
    const qs = params.toString();
    return getRevData(token, qs ? `/churn_external?${qs}` : "/churn_external");
}


export async function logPageView(ref) {
    // Check localStorage for previous logs
    const pageViewData = localStorage.getItem('pageViewLogged');
    let shouldLog = true;
    
    if (pageViewData) {
        try {
            const data = JSON.parse(pageViewData);
            
            if (ref) {
                // For ref visits: only skip if same ref was already logged
                if (data.ref === ref) {
                    shouldLog = false;
                }
            } else {
                // For non-ref visits: skip if already visited
                if (data.visited) {
                    shouldLog = false;
                }
            }
        } catch (e) {
            // Invalid JSON, proceed with logging
            shouldLog = true;
        }
    }
    
    if (!shouldLog) {
        return { status: "cached" };
    }
    
    // Log the view
    let url = `${baseAPIUrl}/log_view`
    if (ref) {
        url += `?ref=${ref}`
    }
    // fire-and-forget analytics: an unreachable backend must never throw into
    // the page (callers don't await this). Skip the localStorage stamp on
    // failure so the view is retried on the next visit.
    let resp;
    try {
        resp = await (await fetch(url, {
            method: "GET",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
        })).json();
    } catch (e) {
        return { status: "error" };
    }

    // Update localStorage
    const newData = {
        visited: true,
        ref: ref || null,
        timestamp: Date.now()
    };
    localStorage.setItem('pageViewLogged', JSON.stringify(newData));
    
    return resp;
}


export async function createUserGoogle(cred, ref) {
        const resp = await (await fetch(`${baseAPIUrl}/sign_in_google_custom`, {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({access_token: cred.access_token, ref: ref})
        })).json();
        return resp;
}

export async function fetchUser(token, errorCallback=(data, status)=> {
    console.error("AUTH ERROR", data, status);
    if (status == 401) {
         try {
             const storedToken = JSON.parse(localStorage.getItem("igenfuntoken"));
             if (storedToken === token) {
                 console.log("[Auth] Removing expired token");
                 localStorage.removeItem("igenfuntoken");
             } else {
                 console.warn("[Auth] 401 with stale token, localStorage has different token - preserving");
             }
         } catch (e) {
             // If parsing fails, remove the token (malformed data)
             console.log("[Auth] Removing malformed token");
             localStorage.removeItem("igenfuntoken");
         }
    }
}) {
    if (token) {
        let q = ""
        const href = window.location.href;
        let u = null;
        if (href.includes("?other=")) {
            q = "?other=1"
        }
        const userResponse = await fetch(`${baseAPIUrl}/me${q}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        if (userResponse.status !== 200) {
            errorCallback(await userResponse.json(), userResponse.status);
            return [null, userResponse.status];
        }
        return [await userResponse.json(), userResponse.status];
    } else {
        return [null, -1];
    }
}


export async function fetchPaymentLink(token, tier) {
    if (token) {
        const userResponse = await fetch(`${baseAPIUrl}/payment?tier=${tier}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return await userResponse.json();
    } else {
        return null;
    }
}

export async function signUp(email, password) {
        const resp = await fetch(`${baseAPIUrl}/sign_up`, {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({email: email, password: password, user_name: email})
        });
        if (resp.status !== 200) {
            const data = await resp.json();
            return data.detail;
        }
        return null;
}

export async function forgotPassword(email) {
        const resp = await fetch(`${baseAPIUrl}/reset_password?`
            + new URLSearchParams({email: email}).toString(), {
            method: "GET"
        });
        if (resp.status !== 200) {
            const data = await resp.json();
            return data.detail;
        }
        return null;
}

export async function requestOTP(email, ref) {
        const resp = await fetch(`${baseAPIUrl}/sign_in_otp/send`, {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({email: email, ref: ref})
        });
        if (resp.status !== 200) {
            return [true, resp.status];
        }
        return [false, resp.status];
}


export async function verifyOTP(email, otp) {
        const resp = await fetch(`${baseAPIUrl}/sign_in_otp/verify`, {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({email: email, opt: otp})
        });

        const data = await resp.json();

        if (resp.status === 200) {
            if (data.hasOwnProperty("access_token")) {
                setToken(data.access_token);
                // window.location.href = `${baseUrl}/editor`;
                return [data, resp.status];
            }
        }

        return [data, resp.status];
}


export async function changePassword(token, password) {
        const resp = await fetch(`${baseAPIUrl}/reset_password/${token}`, {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({password: password, passwordcheck: ""})
        });
        if (resp.status !== 200) {
            const data = await resp.json();
            return data.detail;
        }
        return null;
}

export async function reactivateUser(email) {
        const resp = await fetch(`${baseAPIUrl}/resend_activation`, {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({email: email})
        });
        if (resp.status !== 200) {
            const data = await resp.json();
            return data.detail;
        }
        return null;
}

export function setToken(token) {
    window.localStorage.setItem("igenfuntoken", JSON.stringify(token));
}


export async function signin(email, password) {
        const resp = await fetch(`${baseAPIUrl}/sign_in`, {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({email: email, password: password})
        });
        if (resp.status !== 200) {
            const data = await resp.json();
            return data.detail;
        }
        const data = await resp.json();
        setToken(data.access_token);
        return null;
}


export async function loginFunction(email, password) {
    let res = null;
    fetch(`${baseAPIUrl}/sign_in`, {
        method: "POST",
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({email: email, password: password})
    }).then((response) => {
        response.json().then((data) => {
            if (data.hasOwnProperty("access_token")) {
                setToken(data.access_token);
                // window.location.href = `${baseUrl}/editor`;
            } else {
                res = data.detail;
            }
        })
    });
}

export async function redeemKey(token, key) {
    const resp = await fetch(`${baseAPIUrl}/redeem?key=${encodeURIComponent(key)}`, {
        method: "POST",
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });
    return [await resp.json(), resp.status];
}

export async function createFinbyPayment(token, tier) {
    if (!token) return null;

    const response = await fetch(`${baseAPIUrl}/payment`, {
        method: "POST",
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
            tier: parseInt(tier)
        })
    });

    const data = await response.json();

    if (response.status !== 200 || data.status !== "ok") {
        throw new Error(data.detail || "Payment creation failed");
    }

    return { url: data.gateway_url, paymentRequestId: data.payment_request_id };
}

export async function createSubscription(token, tier) {
    if (!token) return null;

    const response = await fetch(`${baseAPIUrl}/subscription`, {
        method: "POST",
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
            tier: parseInt(tier)
        })
    });

    const data = await response.json();

    if (response.status !== 200 || data.status !== "ok") {
        throw new Error(data.detail || "Subscription creation failed");
    }

    return { url: data.gateway_url };
}

/**
 * @param successPath optional destination key (see finby.SUCCESS_PATHS server-side) for
 *   where the payment lands the user; omit for the default generator page.
 */
export async function createFinbySubscription(token, tier, successPath = null) {
    if (!token) return null;

    const body = { tier: parseInt(tier) };
    if (successPath) body.success_path = successPath;

    const response = await fetch(`${baseAPIUrl}/finby_sub/create`, {
        method: "POST",
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(body)
    });

    const data = await response.json();

    if (response.status !== 200 || data.status !== "ok") {
        throw new Error(data.detail || "Subscription creation failed");
    }

    return { url: data.gateway_url, paymentRequestId: data.payment_request_id };
}

export async function getSubscription(token) {
    if (!token) return [null, -1];

    const response = await fetch(`${baseAPIUrl}/subscription`, {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });

    let data = null;
    try { data = await response.json(); } catch (e) { /* empty body */ }
    return [data, response.status];
}

export async function cancelSubscription(token) {
    if (!token) return [null, -1];

    const response = await fetch(`${baseAPIUrl}/subscription`, {
        method: "DELETE",
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });

    let data = null;
    try { data = await response.json(); } catch (e) { /* empty body */ }
    return [data, response.status];
}

export async function cancelFinbySubscription(token) {
    if (!token) return [null, -1];

    const response = await fetch(`${baseAPIUrl}/finby_sub/cancel`, {
        method: "POST",
        headers: {
            'Accept': 'application/json',
            'Authorization': `Bearer ${token}`
        }
    });

    let data = null;
    try { data = await response.json(); } catch (e) { /* empty body */ }
    return [data, response.status];
}

export async function portalLogin(password) {
    const response = await fetch(`${baseAPIUrl}/sign_in_otp/verify`, {
        method: "POST",
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ email: "tpd", opt: password })
    });

    if (response.status !== 200) {
        const error = await response.json();
        throw new Error(error.detail || 'Invalid password');
    }

    return await response.json();
}


// ── Email + password auth (router_password) ──
// All return [data, status]; data is the parsed JSON body ({status,message} or {detail}).

export async function passwordSignUp(email, password, ref) {
    const resp = await fetch(`${baseAPIUrl}/sign_up`, {
        method: "POST",
        headers: {'Accept': 'application/json', 'Content-Type': 'application/json'},
        body: JSON.stringify({email, password, ref: ref || undefined})
    });
    let data = null;
    try { data = await resp.json(); } catch (e) { /* empty body */ }
    return [data, resp.status];
}

export async function passwordSignIn(email, password) {
    const resp = await fetch(`${baseAPIUrl}/sign_in`, {
        method: "POST",
        headers: {'Accept': 'application/json', 'Content-Type': 'application/json'},
        body: JSON.stringify({email, password})
    });
    let data = null;
    try { data = await resp.json(); } catch (e) { /* empty body */ }
    if (resp.status === 200 && data && data.access_token) {
        setToken(data.access_token);
    }
    return [data, resp.status];
}

export async function resetPasswordStart(email) {
    const resp = await fetch(`${baseAPIUrl}/reset_password/start`, {
        method: "POST",
        headers: {'Accept': 'application/json', 'Content-Type': 'application/json'},
        body: JSON.stringify({email})
    });
    let data = null;
    try { data = await resp.json(); } catch (e) { /* empty body */ }
    return [data, resp.status];
}

export async function resetPasswordFinish(token, password) {
    const resp = await fetch(`${baseAPIUrl}/reset_password/finish`, {
        method: "POST",
        headers: {'Accept': 'application/json', 'Content-Type': 'application/json'},
        body: JSON.stringify({token, password})
    });
    let data = null;
    try { data = await resp.json(); } catch (e) { /* empty body */ }
    return [data, resp.status];
}

export async function activateAccount(token) {
    const resp = await fetch(`${baseAPIUrl}/activate/${encodeURIComponent(token)}`);
    let data = null;
    try { data = await resp.json(); } catch (e) { /* empty body */ }
    if (resp.status === 200 && data && data.access_token) {
        setToken(data.access_token);
    }
    return [data, resp.status];
}

export async function resendActivation(email) {
    const resp = await fetch(`${baseAPIUrl}/resend_activation`, {
        method: "POST",
        headers: {'Accept': 'application/json', 'Content-Type': 'application/json'},
        body: JSON.stringify({email})
    });
    let data = null;
    try { data = await resp.json(); } catch (e) { /* empty body */ }
    return [data, resp.status];
}


// ── Onboarding handoff (igenfun.xyz → this site) ──
// Spends the one-time code the onboarding site puts in the landing URL's fragment
// and returns a normal session for the account behind it. The code is single-use
// and lives 60s: a failed call must never be retried, it is already gone.
// Returns [data, status]; data is {access_token, token_type, ref} or {detail}.
export async function redeemOnboarding(code, ref) {
    const resp = await fetch(`${baseAPIUrl}/redeem_onboarding`, {
        method: "POST",
        headers: {'Accept': 'application/json', 'Content-Type': 'application/json'},
        body: JSON.stringify({code, ref: ref || undefined})
    });
    let data = null;
    try { data = await resp.json(); } catch (e) { /* empty body */ }
    if (resp.status === 200 && data && data.access_token) {
        setToken(data.access_token);
    }
    return [data, resp.status];
}
